import PropTypes from "prop-types";
import {useState} from "react";
import {Link} from "react-router-dom";
import defaultImage from "app/assets/images/no-image.jpg";
import Content from "components/helpers/action-text/content";
import {isBlankHTML} from "lib/ext/string";
import usePagination from "lib/hooks/use-pagination";
import Modal from "./modal";

function Details({record}) {
  const fields = [
    {label: "Birthdate", value: record.birthdate},
    {label: "Future Occupation", value: record.data.future_occupation}
  ].filter(({value}) => value);

  if(fields.length === 0) { return null; }

  return (
    <div>
      {fields.map(({label, value}) => (
        <div key={label}><b>{label}:</b> {value}</div>
      ))}
    </div>
  );
}

Details.propTypes = {
  record: PropTypes.shape({
    birthdate: PropTypes.string,
    data: PropTypes.shape({
      future_occupation: PropTypes.string
    }).isRequired
  }).isRequired
};

export default function Candidates() {
  const {query, records} = usePagination();
  const [modalProps, setModalProps] = useState({});
  const [showModal, setShowModal] = useState(false);

  const onClick = (e, {record}) => {
    e.preventDefault();
    setModalProps({record, sponsored: query.sponsored || false});
    setShowModal(true);
  };

  return (
    <>
      <div className="divide-y flex flex-col gap-4 my-8">
        {records.map((record) => (
          <div key={record.id} className="flex flex-col md:flex-row gap-4 md:items-center pt-4 first:pt-0">
            <div className="flex flex-1 gap-4 flex-col sm:flex-row">
              <button className="btn-none self-start" href={`/candidates/${record.id}`} onClick={(e) => onClick(e, {record})} type="button">
                <img alt={record.name} className="mx-auto max-w-[200px] rounded" src={record.image || defaultImage} />
              </button>
              <div className="flex flex-1 flex-col gap-4">
                <h3>{record.name}</h3>
                {query.sponsored ? (
                  <div>
                    <button className="btn-disabled btn-theme" disabled={true} type="button">Sponsored</button>
                  </div>
                ) : (
                  <>
                    <Details record={record} />
                    {!isBlankHTML(record.story) && <Content className="w-full" html={record.story} />}
                    <div className="flex flex-wrap gap-4">
                      {record.tags.map((tag) => (
                        <Link key={tag.id} className="btn-blue btn-sm" to={`/tags/${tag.id}`}>{tag.name}</Link>
                      ))}
                    </div>
                  </>
                )}
              </div>
            </div>
            {!query.sponsored && (
              <div className="m-auto text-center">
                <Link className="btn-theme" to={`/candidates/${record.id}`}>Sponsor {record.name}</Link>
              </div>
            )}
          </div>
        ))}
      </div>
      {showModal && <Modal {...modalProps} onClose={() => setShowModal(false)} />}
    </>
  );
}
